<template>
  <div style="height: 100%">
    <img class="attendance-bg" src="../assets/images/new_bg.png" alt="" />
    <div class="attendance" v-loading="isLoading">
      <div class="attendance-title">
        <!-- 慧航升本 • 上岸打榜秀 -->
        {{ pageTitle || '慧航升本 • 上岸打榜秀'}}
      </div>
      <img
        class="change-img"
        @click="changeOld"
        src="https://appfile2.sbgw.cn/hhxtj/d27a037e14b44590ba39d89020bbb2ea.png"
        alt=""
      />
      <div class="attendance-main">
        <div class="left-table">
          <!-- 标题 -->
          <div class="left_title flex_test align-center">
            <div class="outer-circle">
              <div class="inner-circle"></div>
            </div>
            <p class="date">{{ currentTime }}</p>
            <div class="day">
              <p>{{ currentWeekDay }}</p>
              <!-- <p>{{ currentDate }}</p> -->
              <span class="date-item">
                <el-date-picker
                  class="date-text test-item"
                  v-model="timeOb"
                  clear-icon="el-icon-date"
                  type="date"
                  placeholder="选择日期"
                  @change="changeDateGo"
                >
                </el-date-picker>
                <i class="el-icon-caret-bottom el_icon_down"></i>
              </span>
            </div>
            <div class="day_bar"></div>
            <div class="flex_test align-center">
              <img class="weather_img" :src="getImageSrc(weatherType)" />
              <div class="weather_text">{{ temperature }}</div>
            </div>
          </div>
          <div class="atten-class-table1" style="height: 43%">
            <div class="table-tt1"><p>上课班级出勤排名</p></div>
            <div class="big_box" v-if="attendanceRanking && attendanceRanking.length > 0">
              <div
                class="attendance_box"
                v-for="(item, index) in attendanceRanking"
                :key="index"
              >
                <div class="flex_test space-between-test">
                  <div class="flex_test align-center">
                    <img
                      v-if="item.orders == 1"
                      class="ranking_img"
                      src="../assets/images/orange_right.png"
                      alt=""
                    />
                    <i class="ranking_num" v-if="item.orders == 1">NO.1</i>
                    <img
                      v-if="item.orders != 1"
                      class="ranking_img"
                      src="../assets/images/blue_right.png"
                      alt=""
                    />
                    <i v-if="item.orders != 1" class="ranking_num blue"
                      >NO.{{ item.orders }}</i
                    >
                    <div class="ranking_grade">{{ item.gradeName }}</div>
                  </div>
                  <div class="attendance_pre flex_test align-center">
                    出勤率：
                    <span
                      class="ranking_pre"
                      :style="item.orders != 1 ? 'color:#E6F2FC;' : '#e8a77d'"
                      >{{ item.ranking }}%</span
                    >
                  </div>
                </div>
                <!-- 进度条 -->
                <div class="progress-bar">
                  <div
                    class="active-bar"
                    :class="item.orders != 1 ? 'blue_bar' : ''"
                    :style="{
                      width: activeBarLength(item.ranking, 100),
                    }"
                  ></div>
                  <div
                    :style="{
                      left: activeBarLength(item.ranking, 100),
                    }"
                    class="bordered-end-ball"
                    :class="
                      item.ranking >= 100
                        ? 'bordered-end-ball2'
                        : item.ranking == 0
                        ? 'bordered-end-ball3'
                        : ''
                    "
                  ></div>
                  <div class="end-ball"></div>
                </div>
              </div>
            </div>
            <div class="big_box gray fs-18" v-else>暂无排名</div>
          </div>
          <div class="atten-class-table1" style="height: 49%">
            <p class="table-tt1">小组学习积分(金币)排行</p>
            <div class="integral-inner">
              <div class="carousel slide integral_carousel">
                <el-carousel
                  v-if="gradeGroupIntegralDtos && gradeGroupIntegralDtos.length > 0"
                  arrow="never"
                  indicator-position="outside"
                >
                  <el-carousel-item
                    v-for="(itm, index) in gradeGroupIntegralDtos"
                    :key="index"
                  >
                    <div v-for="(item,i) in itm" class="item" :key="i">
                      <div class="table-box" v-if="item.gradeTitle">
                        <div class="bg_2">
                          <div class="table-thead">
                            <dl class="table-class-tt">
                              <dt v-if="item.gradeTitle">{{ item.gradeTitle }}</dt>
                              <dt v-else class="gray">未设置</dt>
                            </dl>
                            <dl>
                              <dt>排名</dt>
                              <dt>总金币</dt>
                              <dt>组长</dt>
                              <dt>组名</dt>
                            </dl>
                          </div>
                          <div class="table-tbody tgRoll">
                            <div>
                              <dl
                                v-for="(it,ii) in item.integrals"
                                :key="ii"
                                :class="getRowClass(it.order - 1)"
                              >
                                <dd class="pr-30">
                                  <img
                                    class="ranking_no"
                                    v-if="it.order === 1"
                                    src="../assets/images/no1.png"
                                  />
                                  <i v-if="it.order === 1" class="pb-30">
                                    {{ it.order }}
                                  </i>
                                  <img
                                    class="ranking_no"
                                    v-if="it.order != 1"
                                    src="../assets/images/no2.png"
                                  />
                                  <i v-if="it.order != 1" class="pb-30">
                                    {{ it.order || "暂无排名" }}
                                  </i>
                                </dd>
                                <dd :class="it.order == 1 ? 'special_color' : ''">
                                  {{ it.totalScore }}枚
                                </dd>
                                <dd :class="it.order == 1 ? 'special_color' : ''">
                                  {{ it.groupLeader || "未设置" }}
                                </dd>
                                <dd :class="it.order == 1 ? 'special_color' : ''">
                                  {{ it.integralTeamName }}
                                </dd>
                              </dl>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
                <div style="margin-top: 30px" class="gray fs-18" v-else>暂无数据</div>
              </div>
            </div>
          </div>
        </div>
        <div class="divide3 center-table">
          <p class="table-tt2">全校早到榜前20名</p>
          <div v-if="earlyArrival && earlyArrival.length > 0" class="table-box">
            <div class="table-thead" >
              <dl>
                <dt></dt>
                <dt style="color:#98D7FF;">姓名</dt>
                <dt style="color:#98D7FF;">全校排名</dt>
                <dt style="color:#98D7FF;">时间</dt>
              </dl>
            </div>
            <div class="table-tbody">
              <div>
                <dl
                  v-for="(item, index) in earlyArrival"
                  :key="index"
                  :class="[item.order % 2 === 0 ? 'arrival_box1' : 'arrival_box']"
                >
                  <dd>
                    <div
                      v-if="item.order % 2 != 0 && item.order == 1"
                      class="orange1"
                      style="margin-left: 13px"
                    >
                      <div class="orange-line"></div>
                    </div>
                    <div v-else class="blue1" style="margin-left: 13px">
                      <div class="blue-line"></div>
                    </div>
                  </dd>
                  <dd>{{ item.studentName }}</dd>
                  <dd>NO.{{ item.order }}</dd>
                  <dd>{{ item.signTime | signTime }}</dd>
                </dl>
              </div>
            </div>
          </div>
          <div style="margin-top: 30px" class="gray fs-18" v-else>暂无数据</div>
        </div>
        <div class="right-table">
          <!-- 标题 -->
          <div class="left_title flex_test flex-wrap flex_end">
            <div class="msg_box flex_test align-center flex-wrap mt--10">
              <img
                class="word-img"
                src="https://appfile2.sbgw.cn/hhxtj/71678b53cc6e4178ba229d96ae1ff191.png"
                alt=""
              />
              <div class="word-tt">今日寄语：</div>
              <div class="word-list" id="tgCars">
                <ul ref="tgars">
                  <li
                    class="flex_test align-center flex-wrap"
                    v-for="(item, index) in todayMessagesList"
                    :key="index"
                  >
                    <div>{{ item.key }}</div>
                    <div>寄语:{{ item.value }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="atten-class-table1  mt--10" style="height: 45%">
            <p class="table-tt3">今日迟到榜前<span class="num-text">20</span>名</p>
            <div v-if="studentLateRanking && studentLateRanking.length > 0" class="table-box">
              <div class="table-tbody">
                <div>
                  <div
                    v-for="(item, index) in studentLateRanking"
                    :key="index"
                    class="flex_test align-center border_icon space-between-test"
                  >
                    <div class="flex_test align-center">
                      <div class="flex_test align-center">
                        <img
                          class="arrow_right"
                          src="https://appfile2.sbgw.cn/hhxtj/be72eba06bfc4378ab861c3ce3e351e1.png"
                        />
                        <div class="student_name">{{ item.studentName }}</div>
                      </div>
                      <div class="grade_name">{{ item.gradeName }}</div>
                    </div>
                    <div class="flex_test align-center late_box">
                      迟到
                      <div class="timeout-text">{{ item.lateMinutes }}</div>
                      分钟
                      <img
                        class="late_img"
                        src="https://appfile2.sbgw.cn/hhxtj/d45f2ec78d5b46baa50ec611288c9b26.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 30px" class="gray fs-18" v-else>暂无数据</div>
          </div>
          <div class="atten-class-table1" style="height: 50%">
            <p class="table-tt1">班级学习积分(金币)排行</p>
            <div v-if="gradeIntegraMemberDataDtos&&gradeIntegraMemberDataDtos.length>0" class="integral-inner">
              <div class="carousel slide integral_carousel">
                <el-carousel arrow="never" indicator-position="outside">
                  <el-carousel-item
                    type="card"
                    v-for="(ite, index) in gradeIntegraMemberDataDtos"
                    :key="index"
                  >
                    <div v-for="(item, index) in ite" class="item" :key="index">
                      <div class="table-box" v-if="item.gradeTitle">
                        <div class="bg_2">
                          <div class="table-thead">
                            <dl class="table-class-tt">
                              <dt v-if="item.gradeTitle">
                                {{ item.gradeTitle ? item.gradeTitle : "未设置" }}
                              </dt>
                              <dt v-else class="gray">未设置</dt>
                            </dl>
                            <dl>
                              <dt>排名</dt>
                              <dt>姓名</dt>
                              <dt>所在小组</dt>
                              <dt>总金币</dt>
                            </dl>
                          </div>
                          <div class="table-tbody tgRoll">
                            <div v-if="item.integralMembers">
                              <dl v-for="it in item.integralMembers" :key="it.studentId">
                                <dd class="pr-30">
                                  <img
                                    class="ranking_no"
                                    v-if="it.order === 1"
                                    src="../assets/images/no1.png"
                                  />
                                  <i v-if="it.order === 1" class="pb-30">{{
                                    it.order
                                  }}</i>
                                  <img
                                    class="ranking_no"
                                    v-if="it.order != 1"
                                    src="../assets/images/no2.png"
                                  />
                                  <i
                                    class="pb-30"
                                    v-if="it.order != 1"
                                    :class="it.order === 0 ? 'gray' : ''"
                                    >{{ it.order || "暂无排名" }}</i
                                  >
                                </dd>
                                <dd
                                  :class="
                                    it.studentName && it.studentName.length > 0
                                      ? ''
                                      : 'gray'
                                  "
                                >
                                  {{ it.studentName || "未填写" }}
                                </dd>
                                <dd>{{ it.integralTeamName }}</dd>
                                <dd>{{ it.totalScore }}枚</dd>
                              </dl>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <div style="margin-top: 30px" class="gray fs-18" v-else>暂无数据</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// jQuery
import $ from "jquery";
import { AttendanceMonitoringMap,AttendanceMonitoringMapV2_1,AttendanceMonitoringMapV2_2 } from "network/radar";
import { timeFormatNew, isNull } from "common/utils";
export default {
  name: "AshoreRanking",
  data() {
    return {
      timeOb: new Date(),
      attendanceRanking: [], //出勤率
      earlyArrival: [], //今日全校早到榜前20名
      gradeGroupIntegralDtos: [], //班级小组学习积分（金币）排行榜
      gradeIntegraMemberDataDtos: [], //小组学员个人学习积分（金币）排行榜
      studentLateRanking: [], //今日迟到榜前20名
      todayMessagesList: [],
      urlTime: "",
      timer: null,
      timer2: null,
      currentTime: "",
      currentWeekDay: "",
      currentDate: "",
      pageTitle: "",
      timeSet: "",
      weatherType: "",
      temperature: "",
      intervalId:'',
      isLoading: false,
    };
  },
  filters: {
    signTime(tiem) {
      return timeFormatNew(tiem, "hh:mm");
    },
  },
  computed: {},
  created() {
        // 检查登录状态
    const isLogin = sessionStorage.getItem('isLogin');
    if (isLogin == 'false' || isLogin === null) {
      // 设置大屏标识
      sessionStorage.setItem('isLargeScreen', 'true');
      // 存储当前页面路径，用于登录后跳转回来
      sessionStorage.setItem('largeScreenPath', this.$route.fullPath);
      
      // 弹出提示框
      this.$confirm('请账号密码登录或钉钉扫码登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        // 用户点击确定后跳转到登录页面
        this.$router.push('/');
      }).catch(() => {
        // 用户点击取消，清除大屏标识
      });
      return;
    }
    this.updateTime();
    let that = this;
    // 排行榜滚动
    var time = setInterval(function () {
      that.Scroll();
    }, 5000);
  },
  mounted() {
    this.intervalId  = setInterval(this.startTimer, 600000);// 每10分钟（600000毫秒）执行一次
    // 初始化调用接口
    this.executionOrder();
    this.timer2 = setInterval(this.scroll, 3000);
  },
  beforeDestroy() {
    if (this.timeSet) {
      clearInterval(this.timeSet); // 组件销毁前清除定时器
    }
    if (this.timer) {
      clearInterval(this.timer); // 组件销毁前清除定时器
    }
    if (this.timer2) {
      clearInterval(this.timer2); // 组件销毁前清除定时器
    }
    if (this.intervalId) {
      clearInterval(this.intervalId); // 组件销毁前清除定时器
    }
  },
  methods: {
    isNull,
    getImageSrc(weatherType) {
      if (weatherType?.includes('云')) return 'https://appfile2.sbgw.cn/hhxtj/2fff8c51447d470495e123ee64c421e5.png';
      if (weatherType?.includes('雨')) return 'https://appfile2.sbgw.cn/hhxtj/dafe68ee897240d0a24d2ffcb41f485f.png';
      if (weatherType?.includes('雪')) return 'https://appfile2.sbgw.cn/hhxtj/fcced926fa5543339ca2e30324ec48cc.png';
      if (weatherType?.includes('晴') || weatherType?.includes('阳')) return 'https://appfile2.sbgw.cn/hhxtj/0d770c0355dc4fb8bc36fa3f6d40e4ec.png';
      // 可以在这里添加默认情况
      return 'https://appfile2.sbgw.cn/hhxtj/2fff8c51447d470495e123ee64c421e5.png'; // 返回默认图片路径
    },
    startTimer() {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      // 检查是否在目标时间段内
      if ((currentHour === 7 && currentMinute >= 30) || 
          (currentHour === 10 && currentMinute <= 30) ||
          (currentHour === 12 && currentMinute >= 30) || 
          (currentHour === 15 && currentMinute <= 30)) {
        this.executionOrder();
      }
    },
    updateTime() {
      // 获取当前时间
      const now = new Date();
      // 格式化时间为字符串
      const formattedTime = now.toLocaleTimeString();
      this.currentTime = formattedTime;
      // 每秒更新一次时间
      setTimeout(() => this.updateTime(), 1000);
      // 获取当前日期
      const nowDay = new Date();
      // 获取星期几
      const weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      const dayOfWeek = weekDays[nowDay.getDay()];
      this.currentWeekDay = dayOfWeek;

      // 格式化日期
      const year = nowDay.getFullYear();
      const month = String(nowDay.getMonth() + 1).padStart(2, "0");
      const day = String(nowDay.getDate()).padStart(2, "0");
      this.currentDate = `${year}/${month}/${day}`;
    },
    scroll() {
      setTimeout(() => {
        this.attendanceRanking.push(this.attendanceRanking[0]); // 将数组的第一个元素添加到数组的最后
        this.attendanceRanking.shift(); //删除数组的第一个元素
        if(this.studentLateRanking?.length > 5){
          this.studentLateRanking.push(this.studentLateRanking[0]); // 将数组的第一个元素添加到数组的最后
          this.studentLateRanking.shift(); //删除数组的第一个元素
        }
        this.earlyArrival.push(this.earlyArrival[0]); // 将数组的第一个元素添加到数组的最后
        this.earlyArrival.shift(); //删除数组的第一个元素
      }, 1000);
    },
    getRowClass(index) {
      // 三种颜色
      const colors = ["row1", "row2", "row3", "row4", "row5", "row6"];
      return colors[index % colors.length];
    },
    activeBarLength(learned, total) {
      if (total === 0) return "0%";
      if (learned >= total) return "100%";
      if (learned < total) return (learned / total) * 100 + "%";
    },
    async executionOrder() {
      let timeGet = timeFormatNew(this.timeOb, "yyyy-MM-dd");
      if (this.$route.query.dt) {
        this.timeOb = this.$route.query.dt;
        // await this.getAttendanceMonitoringMap(this.$route.query.dt);
        await this.getAttendanceMonitoringMap1(this.$route.query.dt);
        await this.getAttendanceMonitoringMap2(this.$route.query.dt);
      } else {
        // await this.getAttendanceMonitoringMap(timeGet);
        await this.getAttendanceMonitoringMap1(timeGet);
        await this.getAttendanceMonitoringMap2(timeGet);
      }
      this.$nextTick(() => {
        this.lunbo();
      });
    },
    Scroll() {
      $(".tgRoll").each(function () {
        var area = $(this);
        //单行高度
        var he = area.find("dl").height();
        //单次滚动行数
        // var lines = parseInt(area.height()/he);
        var lines = 4;
        if (area.height() >= area.find("dl").length * he) {
          return;
        } else {
          area.find("div").animate(
            {
              marginTop: "-" + he * lines,
            },
            200,
            function () {
              for (let i = 1; i <= lines; i++) {
                area.find("dl:first").appendTo(area.find("div"));
              }
              area.find("div").css({
                marginTop: 0,
              });
            }
          );
        }
      });
    },
    lunbo() {
      if (this.todayMessagesList.length > 0) {
        var oUl = $("#tgCars>ul")[0];
        var lis = oUl.getElementsByTagName("li");
        oUl.innerHTML += oUl.innerHTML;
        oUl.style.width = lis.length * lis[0].offsetWidth + "px";
        var left = null;
        // 清除旧的定时器
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(function () {
          left -= 3;
          if (left < -oUl.offsetWidth / 2) {
            left = 0;
          }
          oUl.style.left = left + "px";
        }, 50);
      } else {
      }
    },
    // // 获取数据 -- 旧
    // async getAttendanceMonitoringMap(timeGet) {
    //   const res = await AttendanceMonitoringMap(timeGet);
    //   let result = JSON.parse(JSON.stringify(res.data));
    //   if (result.code === 1) {
    //     this.pageTitle = result.result.pageTitle;
    //     this.weatherType = result.result.weatherType;
    //     this.temperature = result.result.temperature;
    //     this.attendanceRanking = result.result.attendanceRanking;
    //     this.attendanceRanking.forEach((item, index) => {
    //       item.orders = index + 1;
    //     });
    //     this.earlyArrival = result.result.earlyArrival;
    //     this.gradeGroupIntegralDtos = result.result.gradeGroupIntegralDtos;
    //     this.gradeIntegraMemberDataDtos = result.result.gradeIntegraMemberDataDtos;

    //     this.studentLateRanking = result.result.studentLateRanking;
    //     this.todayMessagesList = result.result.todayMessagesList;
    //     // 格式化二维数组
    //     this.gradeIntegraMemberDataDtos = this.ceildata(
    //       this.gradeIntegraMemberDataDtos,
    //       6
    //     );
    //     this.gradeGroupIntegralDtos = this.ceildata(this.gradeGroupIntegralDtos, 6);
    //   }
    // },
    // 获取数据标题天气温度 早到 迟到
    async getAttendanceMonitoringMap1(timeGet) {
      const res = await AttendanceMonitoringMapV2_1(timeGet);
      
      let result = JSON.parse(JSON.stringify(res.data));
      if (result.code === 1) {
        this.pageTitle = result.result.pageTitle;
        this.weatherType = result.result.weatherType;
        this.temperature = result.result.temperature;
        this.earlyArrival = result.result.earlyArrival;
        this.studentLateRanking = result.result.studentLateRanking;
      }
    },
     // 获取数据
     async getAttendanceMonitoringMap2(timeGet) {
      this.isLoading = true;
      const res = await AttendanceMonitoringMapV2_2(timeGet);
      let result = JSON.parse(JSON.stringify(res.data));
      this.isLoading = false;
      if (result.code === 1) {
        this.attendanceRanking = result.result.attendanceRanking;
        this.attendanceRanking.forEach((item, index) => {
          item.orders = index + 1;
        });
        this.todayMessagesList = this.attendanceRanking.map(item=>{
          return {
            key:item.gradeName,
            value:item.todayMessage
          }
        })
        this.gradeGroupIntegralDtos = result.result.gradeGroupIntegralDtos;
        this.gradeIntegraMemberDataDtos = result.result.gradeIntegraMemberDataDtos;
        // 格式化二维数组
        this.gradeIntegraMemberDataDtos = this.ceildata(
          this.gradeIntegraMemberDataDtos,
          2
        );
        this.gradeGroupIntegralDtos = this.ceildata(this.gradeGroupIntegralDtos, 2);
      }
    },
    // 分组
    ceildata(arr, num) {
      let list = [];
      let numdata = Math.ceil(arr.length / num);
      for (var i = 0; i < numdata; i++) {
        const start = i * num;
        const end = start + num;
        list.push(arr.slice(start, end));
      }
      return list;
    },
    async changeDateGo(time) {
      this.timeOb = timeFormatNew(time, "yyyy-MM-dd");
      // window.location.href = "/#/AshoreRanking?dt=" + this.timeOb;
      this.todayMessagesList = [];
      let timeGet = timeFormatNew(this.timeOb, "yyyy-MM-dd");
      await this.getAttendanceMonitoringMap1(timeGet);
      await this.getAttendanceMonitoringMap2(timeGet);
      this.$nextTick(() => {
        this.lunbo();
      });
    },
    changeOld() {
      const url = "/#/RadarStudentsAttendance";
      window.open(url, "_blank");
      this.todayMessagesList = [];
      this.executionOrder();
    },
  },
};
</script>
<style scoped src="../assets/css/ashore.css"></style>
<style scoped>
.mt--10{
  margin-top: -10px !important;
}
div {
  box-sizing: border-box;
}
.flex_test {
  display: flex;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #1e2734;
  border-radius: 60px;
  display: flex;
  position: relative;
  float: left;
  margin-top: 1px;
}

.active-bar {
  width: 69px;
  height: 8px;
  background: linear-gradient(90deg, rgba(232, 167, 125, 0.3), #e8a77d);
  box-shadow: 0px 4px 12px 0px rgba(250, 145, 70, 0.3);
  border-radius: 12px;
}
.blue_bar {
  background: linear-gradient(90deg, rgba(174, 214, 247, 0.3), #aed6f7);
}
/* .end-ball {
  width: 8px;
  height: 8px;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 100px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
} */

.bordered-end-ball {
  width: 20px; /* 外层圆的直径 */
  height: 20px;
  border: 0.5px solid #eaedef; /* 设置边框宽度和颜色 */
  border-radius: 50%; /* 将四角变成圆形 */
  position: absolute;
  top: -89%; /* 垂直居中对齐 */
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-42%, 5%);
}
.bordered-end-ball2 {
  transform: translate(-81%, 5%) !important;
}
.bordered-end-ball3 {
  display: none;
}
.end-ball {
  width: 8px; /* 内层圆的直径 */
  height: 8px;
  border-radius: 50%; /* 将四角变成圆形 */
  background-color: #fff; /* 内层圆的颜色 */
  transform: translate(-38%, 1%);
}
.left-table,
.center-table,
.right-table {
  display: inline-block;
  vertical-align: top;
  height: 100%;
  padding-top: 2%;
  box-sizing: border-box;
}
.left_title {
  color: #fff;
  margin-bottom: 5px;
}

.weather_img {
  width: 33px;
  height: 33px;
}
.right-table {
  width: 38%;
}

.left-table,
.center-table {
  margin-right: 2%;
}

/* @media screen and (max-width:1080px){
    html,body{min-width: 1080px;overflow-x: scroll;} 
    .attendance-bg{width: 1080px;}
    .left-table{width: 412px;}
    .center-table{width: 254px;}
    .right-table{width: 314px;}
    .left-table,.center-table{margin-right:20px;}
} */

.table-thead dl dt,
.table-tbody dl dd {
  float: left;
  font-size: 14px;
  padding: 5px 0px;
  line-height: 35px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 25%;
}
.lateTable .table-thead dl dt:first-child + dt,
.lateTable .table-tbody dl dd:first-child + dd {
  width: 49%;
}

.left-table .table-tbody,
.right-table .table-tbody {
  height: 98%;
}
.left-table {
  padding-top: 0.5% !important;
}
.center-table .table-tbody {
  height: 80%;
}
.center-table {
  padding: 17px 21px 17px 18px;
  background: url("../assets/images/student_bg.png") no-repeat;
  background-size: 100% 90.2%;
  background-position: 0px 57px;
}
.left-table .table-thead dl dt,
.left-table .table-tbody dl dd {
  width: 22%;
}

/*.left-table .table-thead dl dt:first-child,.left-table .table-thead dl dt:last-child,.left-table .table-tbody dl dd:first-child,.left-table .table-tbody dl dd:last-child{width: 20%;}
.left-table .table-thead dl dt:first-child,.left-table .table-thead dl dt:first-child+dt+dt+dt,.left-table .table-tbody dl dd:first-child,.left-table .table-tbody dl dd:first-child+dd+dd+dd{width: 20%;} IE兼容写法*/

.left-table .table-thead dl dt:first-child,
.left-table .table-tbody dl dd:first-child {
  width: 16%;
}

.left-table .table-thead dl dt:nth-child(2),
.left-table .table-tbody dl dd:nth-child(2) {
  width: 40%;
}

.left-table .table-thead dl dt:first-child + dt,
.left-table .table-tbody dl dd:first-child + dd {
  width: 40%;
}

.divide3 .table-thead dl dt,
.divide3 .table-tbody dl dd {
  width: 23%;
}
.arrival_box {
  height: 46px;
  line-height: 46px;
  background: url("../assets/images/border_early.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}
.arrival_box1 {
  height: 46px;
  line-height: 50px;
  background: url("https://appfile2.sbgw.cn/hhxtj/4bdfde31f8fd4152b7a56ba84cdcd771.png")
    no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}
.circle {
  width: 17px;
  height: 17px;
  background: rgba(129, 219, 246, 0.2);
  border-radius: 50%;
}
.border_icon {
  height: 45px;
  line-height: 25px;
  background: url("https://appfile2.sbgw.cn/hhxtj/55d0806b4ad0465487d5602a0f300638.png")
    no-repeat;
  background-size: 100% 100%;
  margin-bottom: 8px;
  margin-top: 11px;
  padding: 13px 16px 13px 15px;
  box-sizing: border-box;
}
.arrow_right {
  width: 5px;
  height: 10px;
  margin-right: 11px;
}
.student_name {
  color: #ffffff;
  font-family: Alibaba PuHuiTi 2;
  font-weight: 700;
  font-size: 18px;
  background: linear-gradient(0deg, #fff 0%, #eac470 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-right: 25px;
}
.grade_name {
  font-family: Adobe Heiti Std;
  font-weight: normal;
  font-size: 18px;
  color: #ffffff;
}
.late_box {
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 16px;
  color: #ffffff;
}
.timeout-text {
  font-family: Adobe Heiti Std;
  font-weight: 700;
  font-size: 24px;
  color: #ffffff;
  background: linear-gradient(0deg, #ffffff 0%, #d86e46 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0 7px;
}
.late_img {
  width: 22px;
  height: 22px;
  margin-left: 6px;
}
.attendance-footer {
  width: 1440px;
  position: absolute;
  bottom: 15px;
  left: 50%;
  margin-left: -720px;
  text-align: left;
  padding: 0 30px;
  line-height: 36px;
}

.word-tt {
  width: 100px;
  white-space: nowrap;
  font-size: 16px;
  color: #fa9e68;
}

.word-list {
  font-size: 0;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 1300px;
  height: 36px;
  line-height: 55px;
  overflow: hidden;
  margin-bottom: 20px;
}

.word-list ul {
  position: absolute;
  left: 0;
  top: 0;
}

.word-list ul li {
  float: left;
  color: #fff;
  font-size: 16px;
  margin-right: 15px;
}

.atten-class-table1 {
  height: 45%;
  margin-top: 5px;
  padding: 17px 21px 17px 18px;
  background: url("../assets/images/attendance.png") no-repeat;
  background-size: 100% 98%;
  box-sizing: border-box;
}
.big_box {
  height: 80%;
  overflow: hidden;
}
.table-tt1 {
  height: 13.5%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 18px;
  color: #ffffff;
  text-align: left;
  padding-left: 30px;
  background: url("../assets/images/attendance_title.png") no-repeat;
  background-size: 100%;
  margin-top: 3px;
  font-size: 18px;
  line-height: 16px;
}
.table-tt3 {
  height: 8.5%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 18px;
  color: #ffffff;
  text-align: left;
  padding-left: 30px;
  background: url("../assets/images/attendance_title.png") no-repeat;
  background-size: 100%;
  margin-top: 3px;
  font-size: 18px;
  line-height: 16px;
}
.table-tt2 {
  height: 6%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 18px;
  color: #ffffff;
  text-align: left;
  padding-left: 30px;
  background: url("../assets/images/attendance_title.png") no-repeat;
  background-size: 201%;
  margin-top: 72px;
  font-size: 18px;
  line-height: 16px;
}
.attendance_box {
  width: 98%;
  /* margin-left: -5px; */
  margin-bottom: 31px;
}
.ranking_grade {
  font-family: Source-KeynoteartHans;
  font-weight: 400;
  font-size: 14px;
  color: #b8b9ba;
}
.attendance_pre {
  min-width: 20%;
  max-width: 28%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 14px;
  color: #b8b9ba;
  letter-spacing: 1px;
}
.ranking_pre {
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 16px;
  color: #e8a77d;
}
.atten-class-table,
.late-table {
  height: 32%;
}
.atten-class-table .table-tt,
.late-table .table-tt {
  height: 16%;
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 18px;
  color: #ffffff;
  text-align: left;
  padding-left: 30px;
  background: url("../assets/images/attendance_title.png") no-repeat;
  background-size: 100%;
  margin-top: 3px;
  font-size: 17px;
  line-height: 16px;
}

.atten-class-table .table-box,
.late-table .table-box {
  height: 84%;
}
.bg_2 {
  height: 87%;
  background: url("../assets/images/group_bar.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 10px;
  box-sizing: border-box;
}
.integral-box {
  height: 65%;
  overflow: hidden;
}
.integral-box .table-tt {
  margin-top: 4%;
  height: 6%;
}
.integral-inner {
  font-size: 0;
  height: 88%; /* overflow: hidden;display: flex;flex-direction: row; */
  margin-top: -40px;
}
.integral-inner .carousel,
.integral-inner .carousel-inner,
.integral-inner .item {
  height: 100%;
}
.integral-inner .item .table-box {
  height: 100%;
}
.integral-inner .table-box {
  width: 100%;
  height: 100%;
}
.integral-inner .table-box:nth-child(2n) {
  margin-left: 1.5%;
}
.integral-inner .table-box dl.table-class-tt dt {
  width: 100% !important;
}
.table-class-tt {
  font-family: Alibaba PuHuiTi 2;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
  padding-top: 4px;
  box-sizing: border-box;
}
.integral-inner .table-box .table-tbody {
  height: 67%;
}
.integral-inner .carousel-indicators {
  width: 100px;
  left: auto;
  bottom: auto;
  right: 40px;
  top: -32px;
  margin-left: 0;
  text-align: right;
}
.integral-inner .carousel-indicators li {
  width: 6px;
  height: 6px;
  margin-right: 3px;
}
.integral-inner .carousel-indicators li.active {
  width: 8px;
  height: 8px;
}
.integral-inner .carousel-control {
  top: -36px;
  left: auto;
  right: 0;
  bottom: auto;
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url(../assets/images/icon0.png) no-repeat;
  background-size: 145px auto;
}
/* .integral-inner .carousel-control:hover{background-color: rgba(255,255,255,0.6);} */
.integral-inner .carousel-control.left {
  right: 16px;
  background-position: -97px -50px;
}
.integral-inner .carousel-control.right {
  background-position: -117px -50px;
}

/* 轮播 */
>>> .el-carousel--horizontal {
  height: 120%;
  padding-top: 20px;
  overflow-y: hidden;
}
>>> .el-carousel__container {
  height: 100%;
}
.el-carousel__item {
  background: transparent;
}
>>> .el-carousel__indicators--outside {
  top: -106%;
  text-align: right;
  bottom: initial;
  position: relative;
}
>>> .el-carousel__button {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
>>> .el-carousel__indicator.is-active button {
  width: 8px;
  height: 8px;
}
>>> .el-carousel__indicators--horizontal {
  left: auto;
}
.gray {
  color: #c0c0c0;
}
.integral-inner .item {
  width: 49.25%;
  float: left;
  height: 100%;
  margin-right: 1.5%;
  overflow: hidden;
}
.integral-inner .item:nth-child(2n) {
  margin-right: 0;
}
.integral-inner .item:nth-child(3) {
  margin-bottom: 0;
}
.integral-inner .item:nth-child(4) {
  margin-bottom: 0;
}
.date-item{
  margin-left: -10px;
}
</style>
